module.exports = __webpack_public_path__ + "static/img/cts-logo.7898934.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cts-logo.png
// module id = Bt6X
// module chunks = 1